function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import PropTypes from 'prop-types';
import { noop } from '@adsk/alloy-react-helpers';
import Overlay from '@adsk/alloy-react-overlay';
import Portal from '@adsk/alloy-react-portal';
import theme from '@adsk/alloy-react-theme';
import useTooltip from './useTooltip';
var TRIGGER_TARGETS = {
  CHILDREN: 'children',
  TOOLTIP: 'tooltip'
};
var TRIGGER_EVENTS = {
  CLICK: 'click',
  HOVER: 'hover'
};

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      _ref$container = _ref.container,
      container = _ref$container === void 0 ? document.body : _ref$container,
      content = _ref.content,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? Overlay.VARIANTS.DARK : _ref$variant,
      _ref$showArrow = _ref.showArrow,
      showArrow = _ref$showArrow === void 0 ? true : _ref$showArrow,
      _ref$containerPadding = _ref.containerPadding,
      containerPadding = _ref$containerPadding === void 0 ? '8px 12px' : _ref$containerPadding,
      _ref$wrapper = _ref.wrapper,
      wrapper = _ref$wrapper === void 0 ? 'div' : _ref$wrapper,
      _ref$shouldWrapChildr = _ref.shouldWrapChildren,
      shouldWrapChildren = _ref$shouldWrapChildr === void 0 ? true : _ref$shouldWrapChildr,
      arrowColor = _ref.arrowColor,
      _ref$arrowSize = _ref.arrowSize,
      arrowSize = _ref$arrowSize === void 0 ? 5 : _ref$arrowSize,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? [0, 10] : _ref$offset,
      _ref$rootClose = _ref.rootClose,
      rootClose = _ref$rootClose === void 0 ? true : _ref$rootClose,
      _ref$placement = _ref.placement,
      placementProp = _ref$placement === void 0 ? Overlay.PLACEMENTS.TOP : _ref$placement,
      showProp = _ref.show,
      targetRef = _ref.target,
      overlayRef = _ref.overlayRef,
      _ref$getTargetProps = _ref.getTargetProps,
      getTargetProps = _ref$getTargetProps === void 0 ? function () {
    return {};
  } : _ref$getTargetProps,
      _ref$onHide = _ref.onHide,
      onHideProp = _ref$onHide === void 0 ? noop : _ref$onHide,
      _ref$onShow = _ref.onShow,
      onShowProp = _ref$onShow === void 0 ? noop : _ref$onShow,
      _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? TRIGGER_EVENTS.HOVER : _ref$trigger,
      _ref$triggerTarget = _ref.triggerTarget,
      triggerTarget = _ref$triggerTarget === void 0 ? TRIGGER_TARGETS.CHILDREN : _ref$triggerTarget,
      _ref$delayShow = _ref.delayShow,
      delayShow = _ref$delayShow === void 0 ? 500 : _ref$delayShow,
      _ref$delayHide = _ref.delayHide,
      delayHide = _ref$delayHide === void 0 ? 0 : _ref$delayHide,
      dataTestid = _ref['data-testid'];

  var _useTooltip = useTooltip({
    rootClose: rootClose,
    placement: placementProp,
    show: showProp,
    trigger: trigger,
    triggerTarget: triggerTarget,
    delayShow: delayShow,
    delayHide: delayHide,
    onHide: onHideProp,
    onShow: onShowProp,
    getTargetProps: getTargetProps,
    target: targetRef,
    overlayRef: overlayRef,
    offset: offset
  }),
      show = _useTooltip.show,
      placement = _useTooltip.placement,
      interactive = _useTooltip.interactive,
      targetProps = _useTooltip.targetProps,
      overlayProps = _useTooltip.overlayProps,
      arrowProps = _useTooltip.arrowProps;

  var _ref2 = offset || [],
      _ref3 = _slicedToArray(_ref2, 2),
      _ = _ref3[0],
      offsetSize = _ref3[1];

  var arrowTheme = variant === Overlay.VARIANTS.DARK ? theme.colors.charcoal900 : theme.colors.white;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Overlay.Target, _extends({
    wrapper: wrapper,
    shouldWrapChildren: shouldWrapChildren
  }, targetProps), children), show && Boolean(content) && /*#__PURE__*/React.createElement(Portal, {
    container: container
  }, /*#__PURE__*/React.createElement(Overlay.Container, _extends({
    placement: placement,
    "data-testid": dataTestid
  }, overlayProps), showArrow && /*#__PURE__*/React.createElement(Overlay.Arrow, {
    ref: arrowProps.ref,
    style: arrowProps.style,
    placement: placement,
    size: "".concat(arrowSize, "px"),
    color: arrowColor ? arrowColor : arrowTheme
  }), /*#__PURE__*/React.createElement(Overlay.Body, {
    className: className,
    style: style,
    padding: containerPadding,
    variant: variant
  }, content), interactive && /*#__PURE__*/React.createElement(Overlay.Blank, {
    placement: placement,
    size: offsetSize
  }))));
};

Tooltip.displayName = 'Tooltip';
Tooltip.propTypes = {
  /**
   * className to add to the tooltip overlay
   */
  className: PropTypes.string,

  /**
   * style to tooltip overlay
   */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),

  /**
   * The contents to show within the popover.
   * hidden when no content available
   */
  content: PropTypes.node,

  /**
   * The content of the element to which the tooltip is applied
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,

  /**
   * Tooltip variant
   */
  variant: PropTypes.oneOf(Object.values(Overlay.VARIANTS)),

  /**
   * whether the showing is triggered by click or mouseover
   */
  trigger: PropTypes.oneOf(Object.values(TRIGGER_EVENTS)),

  /**
   * The Overlay target (either the children or the tooltip itself)
   */
  triggerTarget: PropTypes.oneOf(Object.values(TRIGGER_TARGETS)),

  /**
   * Function getter props for trigger functions.
   *  */
  getTargetProps: PropTypes.func,

  /**
   * Overlay position according to Overlay placements.
   * */
  placement: PropTypes.oneOf(Object.values(Overlay.PLACEMENTS)),

  /**
   * Target element ref (get/set).
   * */
  target: PropTypes.object,

  /**
   * Overlay ref to overlay dom element.
   *  */
  overlayRef: PropTypes.any,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay.
   * */
  rootClose: PropTypes.bool,

  /**
   * Dependency to pass to usePopper's useLayoutEffect hook
   * */
  layoutDependency: PropTypes.any,

  /**
   * whether the popover is showed or not. should be sent only for
   * controlled elements
   */
  show: PropTypes.bool,

  /**
   * callback to be called on show
   */
  onShow: PropTypes.func,

  /**
   * callback to be called on hide
   */
  onHide: PropTypes.func,

  /**
   * delay before show in milliseconds
   */
  delayShow: PropTypes.number,

  /**
   * delay before hide in milliseconds
   */
  delayHide: PropTypes.number,

  /**
   * whether to not have the arrow - show and default to true
   */
  showArrow: PropTypes.bool,

  /**
   * arrow color, eg: red, #000000, rgba(128,128,128,0.5)
   */
  arrowColor: PropTypes.string,

  /**
   * arrow size number in pixels
   */
  arrowSize: PropTypes.number,

  /**
   * should wrap children with `wrapper` element,
   * note it will overwrite your events onClick,
   * onMouseEnter, onMouseLeave, onFocus, onBlur
   */
  shouldWrapChildren: PropTypes.bool,

  /**
   * wrap children as element eg: div or span
   */
  wrapper: PropTypes.string,

  /**
   * Control how much space there is between the edge of the boundary element and overlay.
   */
  containerPadding: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default Object.assign(Tooltip, {
  VARIANTS: Overlay.VARIANTS,
  PLACEMENTS: Overlay.PLACEMENTS,
  TRIGGER_EVENTS: TRIGGER_EVENTS,
  TRIGGER_TARGETS: TRIGGER_TARGETS
});
//# sourceMappingURL=Tooltip.js.map